import React from 'react'
import cn from 'classnames'

import './styles.scss'

const baseClass = 'user-board-main-color-item'
const width = '10'
const height = '10'

const ColorItem = ({ name, actionType, t }) => (
  <div className={baseClass}>
    <svg width={width} height={height}>
      <rect
        width={width}
        height={height}
        className={cn(`${baseClass}__rect`, {
          [`${baseClass}__rect--did`]: actionType === 'did',
          [`${baseClass}__rect--did-not`]: actionType === 'didnot',
          [`${baseClass}__rect--today`]: actionType === 'today',
          [`${baseClass}__rect--completed-not`]: actionType === 'notcompleted',
        })}
      />
    </svg>
    <span className={`${baseClass}__color-name`}>{t(name)}</span>
  </div>
)

export default ColorItem
